import { Suspense, lazy } from 'react';
import { createBrowserRouter, Navigate, Outlet, useNavigate } from 'react-router-dom';
import { AuthCallback, AuthGuard } from '@os/auth-client/react';
import { Spinner } from '@os/ui';
import { Shell } from '../layout/Shell';
import { addonWeb } from '../addons/catalog';
import { AddonGate } from '../addons/AddonGate';

// Pages are lazy (§51).
const Home = lazy(() => import('../pages/home/HomePage'));
const Editor = lazy(() => import('../pages/editor/EditorPage'));
const Queue = lazy(() => import('../pages/queue/QueuePage'));
const Log = lazy(() => import('../pages/log/LogPage'));
const Presets = lazy(() => import('../pages/presets/PresetsPage'));
const Settings = lazy(() => import('../pages/settings/SettingsPage'));
const Addons = lazy(() => import('../pages/settings/AddonsPage'));

function Loading() {
  return <div style={{ display: 'grid', placeItems: 'center', flex: 1, minHeight: 240 }}><Spinner /></div>;
}

function Callback() {
  const nav = useNavigate();
  return <AuthCallback onComplete={(to) => nav(to, { replace: true })} />;
}

const addonRoutes = addonWeb.flatMap((m) =>
  m.routes.map((r) => ({ ...r, element: <AddonGate addonId={m.id}>{r.element}</AddonGate> })),
);

export const router = createBrowserRouter([
  { path: '/auth/callback', element: <Callback /> },
  {
    path: '/',
    element: (
      <AuthGuard>
        <Shell>
          <Suspense fallback={<Loading />}>
            <Outlet />
          </Suspense>
        </Shell>
      </AuthGuard>
    ),
    children: [
      { index: true, element: <Home /> },
      { path: 'editor', element: <Editor /> },
      // Same screen with an image already selected.
      { path: 'editor/:assetId', element: <Editor /> },
      { path: 'queue', element: <Queue /> },
      { path: 'log', element: <Log /> },
      { path: 'presets', element: <Presets /> },
      { path: 'settings/addons', element: <Addons /> },
      { path: 'settings', element: <Settings /> },
      ...addonRoutes,
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
]);
